// Column sizing (min/max width + wrapping) is owned entirely by MTCommonTable.
// Do not add hardcoded width/minWidth/maxWidth here.
export const MT_ASSIGN_ENTITY_COLUMNS = [
  { id: 'username', label: 'User ID', width: '136px', minWidth: '120px' },
  {
    id: 'name',
    label: 'User name',
    width: '136px',
    minWidth: '120px',
    // Not a valid advanced-search filter on this multi-country grid (mirrors
    // India): the field can't be filtered per-request and returned 0 rows.
    searchable: false,
  },
  { id: 'entityName', label: 'Entity name', width: '136px', minWidth: '120px' },
  { id: 'countryName', label: 'Country', width: '136px', minWidth: '100px' },
  {
    id: 'taxDeductionAccountNumber',
    label: 'Tax identification number',
    width: '250px',
    minWidth: '200px',
    // Show TAN when applicable, otherwise fall back to the entity PAN.
    render: (_value: unknown, row: Record<string, unknown>) =>
      row?.tanApplicable
        ? (row?.taxDeductionAccountNumber ?? '')
        : (row?.entityPan ?? ''),
  },
  { id: 'createdBy', label: 'Assigned by' },
  {
    id: 'createdDate',
    label: 'Assigned date',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
  },
]
